import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { CircularProgress, Container, Typography } from '@mui/material';

export default function PostBilling() {
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user) {
          navigate('/login');
          return;
        }
        const userId = session.user.id;

        const { data: profile } = await supabase
          .from('user_profiles')
          .select('company_id')
          .eq('user_id', userId)
          .maybeSingle();

        const companyId = profile?.company_id || null;
        if (!companyId) {
          navigate('/onboarding/usage-choice');
          return;
        }

        const { data: subscription } = await supabase
          .from('company_subscriptions')
          .select('status')
          .eq('company_id', companyId)
          .eq('status', 'active')
          .maybeSingle();

        if (subscription) {
          navigate('/chat');
        } else {
          navigate('/pricing');
        }
      } catch (_) {
        navigate('/pricing');
      }
    };
    run();
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Finalizing your subscription...
      </Typography>
    </Container>
  );
}





